import { z } from 'zod';
/**
 * A line the server writes for a player, in French with its values filled
 * (`text`), plus the French template and its values (`key`, `params`) so a
 * client in another language translates the template and fills it itself
 * (ADR 0069). The server never learns the player's language: it always sends
 * both, and a client that knows no `key` shows `text`.
 */
export const PHRASE_KEY_MAX = 200;
export const PhraseParamsSchema = z.record(z.string().regex(/^\w{1,24}$/), z.union([z.string().max(200), z.number()]));
/** The optional fields a message with a server-written line carries beside its `text`. */
export const PhraseFieldsSchema = z.object({
    key: z.string().min(1).max(PHRASE_KEY_MAX).optional(),
    params: PhraseParamsSchema.optional(),
});
/** `{name}` placeholders replaced by their value; one without a value is left as written. */
export function fillPhrase(template, params) {
    return template.replace(/\{(\w+)\}/g, (whole, name) => {
        const value = params[name];
        return value === undefined ? whole : String(value);
    });
}
/** A templated line: its French, and the template with its values for other languages. */
export function phrase(key, params) {
    return { text: fillPhrase(key, params), key, params };
}
/**
 * The body of an HTTP refusal: a code, the French line the player reads, and
 * for a line with values the template to translate.
 */
export const HttpRefusalSchema = z
    .object({
    error: z.string().optional(),
    details: z.array(z.string()).optional(),
})
    .extend(PhraseFieldsSchema.shape);
/** `{ details, key?, params? }` for a refusal body, from a fixed line or a templated one. */
export function refusalDetails(line) {
    if (typeof line === 'string')
        return { details: [line] };
    return {
        details: [line.text],
        ...(line.key !== undefined && { key: line.key }),
        ...(line.params !== undefined && { params: line.params }),
    };
}
//# sourceMappingURL=phrase.js.map